package com.upcominds.expedite.data.achievements

import com.upcominds.expedite.data.NetworkClient
import com.upcominds.expedite.dto.BadgeDTO
import io.ktor.client.HttpClient
import io.ktor.client.call.body
import io.ktor.client.request.get
import io.ktor.client.request.parameter

class AchievementsRepositoryImpl : AchievementsRepository {
    private val httpClient: HttpClient = NetworkClient.httpClient

    override suspend fun getMyAchievements(communityId: String): List<BadgeDTO> =
        httpClient.get(NetworkClient.endpoint("api/badges/me")) {
            parameter("communityId", communityId)
        }.body()
}
